module.exports = __webpack_public_path__ + "static/media/bilotta.b13c4d15.png";